import Layout from '../modules/Layout';
import Business from '../modules/Business';
import { CustomNextPage } from '../lib/types';
import { FEATURE_BLOCKS_FRAGMENT } from '../lib/core/fragments/featureBlocks';
import { ApolloQueryResult, gql } from '@apollo/client';
import { businessPageQuery } from '../core-types';
import { bootstrap } from '../lib/bootstrap';

const BUSINESS_PAGE_QUERY = gql`
  ${FEATURE_BLOCKS_FRAGMENT}
  query businessPageQuery {
    system {
      id
      cityName
    }
    businessPage: sanityBusinessPage {
      title
      heading
      description
      featureBlocks {
        ...FeatureBlocks
      }
    }
  }
`;

const BusinessPage: CustomNextPage<{
  businessPageQueryResult: ApolloQueryResult<businessPageQuery>;
  statusCode?: number;
}> = props => {
  const { url, businessPageQueryResult, statusCode } = props;
  const { loading, data } = businessPageQueryResult;

  const title = data && data.businessPage && data.businessPage.title;

  return (
    <Layout
      statusCode={statusCode}
      title={title}
      url={url}
      loading={loading}
      contentProps={{
        // Override Content defaultProps
        py: 0,
        mx: 0,
        mb: 0
      }}
      render={({ appContent }) => {
        if (!data || !data.businessPage) {
          return null;
        }
        return <Business data={data} appContent={appContent} />;
      }}
    />
  );
};

BusinessPage.getInitialProps = async ctx => {
  const businessPageQueryResult = await ctx.apolloClient.query<
    businessPageQuery
  >({
    query: BUSINESS_PAGE_QUERY
  });
  let statusCode;
  if (!businessPageQueryResult.data?.businessPage) {
    statusCode = 404;
    if (ctx.res) {
      // eslint-disable-next-line require-atomic-updates
      ctx.res.statusCode = statusCode;
    }
  }

  return {
    businessPageQueryResult,
    statusCode
  };
};

export default bootstrap(BusinessPage);
